import { createFileRoute } from '@tanstack/react-router';

import { getProductServiceQueryOptions } from '@/_pages/products-and-services/api-service';
import Loading from '@/_pages/products-and-services/profile/loading';

export const Route = createFileRoute('/_private/products-and-services/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getProductServiceQueryOptions(opts.params.id)),
  // params: {
  //   parse: (params) => ({
  //     id: z.number().int().parse(Number(params.id)),
  //   }),
  //   stringify: ({ id }) => ({ id: `${id}` }),
  // },
  pendingComponent: Loading,
});
